import axios from "axios";
import { urls } from "@api";
const { issues } = urls;
import {
  IFindIssue,
  IIssues,
  ResponseCreateIssues,
} from "@api/services/issues/interface";

export const createIssu = async (issue: IIssues, file: File) => {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  const url = `${issues}/issues`;
  const urlImage = `${issues}/issues/image`;
  const { data } = await axios.post<ResponseCreateIssues>(url, issue);
  const { serial } = data;
  if (file) {
    const multipart = new FormData();
    multipart.append("file", file);
    multipart.append("serial", serial);
    multipart.append("isUser", "true");
    await axios.post(urlImage, multipart, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  }

  return serial;
};

export const findIssu = async ({ docType, document, serial }: IFindIssue) => {
  const url = `${issues}/issues/clientSearch?identification=${document}&serial=${serial}&documentType=${docType}`;
  const response = await axios.get(url);
  return response.data;
};
